import { useAzureAuth } from "@datamole/wds-azure-auth";
import { Menu } from "@datamole/wds-component-menu";
import { Sidebar } from "@datamole/wds-component-sidebar";

import { ButtonSidebarItem } from "@/components/shared/app-layout/sidebar/sidebar-item/button-sidebar-item";
import { Button } from "@/components/ui/button";
import { LogoutIcon, UserMenuIcon } from "@/components/ui/icon";

const UserMenu = () => {
    const { triggerLogout, user } = useAzureAuth();

    return (
        <Menu>
            <Menu.Trigger asChild>
                <ButtonSidebarItem icon={<UserMenuIcon />}>
                    <Sidebar.Item.Content>{user?.name ?? user?.username}</Sidebar.Item.Content>
                </ButtonSidebarItem>
            </Menu.Trigger>
            <Menu.Content
                align="end"
                side="right"
                onOpenAutoFocus={(ev) => {
                    ev.preventDefault();
                }}
            >
                <Menu.Content.Item asChild>
                    <Button onClick={triggerLogout} startIcon={<LogoutIcon />}>
                        Log out
                    </Button>
                </Menu.Content.Item>
            </Menu.Content>
        </Menu>
    );
};

export { UserMenu };
